/* eslint-disable */
import {extendDecorator} from '@/js/common/Domain/Service/mixins/decorators';
import HotelPageModel from '@/js/desktop/components/hotel/model/HotelPageModel';

@extendDecorator({
    defaults: {
        fotoramaDivs: {},
        isDisabled: true,
    },
    computeds: {
        minPriceBySearchDatesText: {
            deps: ['minPriceBySearchDates'],
            get(minPrice) {
                if (minPrice) {
                    return `(от ${minPrice.formatNumber()} руб.)`;
                }
                return '';
            },
        },
    },
})
export default class HotelPageSeoModel extends HotelPageModel {
}